import { render } from "./GrowingNumber.vue?vue&type=template&id=58409cc6"
import script from "./GrowingNumber.vue?vue&type=script&lang=js"
export * from "./GrowingNumber.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__